import React, { useState } from "react";
import "./Gallery.css";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import NavBar from "../NavBar/NavBar";
import {GalleryPhoto} from "../../Data"

const Gallery = () => {
    const [isNavExpanded, setIsNavExpanded] = useState(false);
  return (
    <>
     <NavBar/>
      <div className='about-kiga-slide-page' style={{background:`linear-gradient(to top, rgba(000, 000, 000, 0.52), rgba(000, 000, 000, 0.73)),
             url('images/moving2.jpg')`,
             backgroundAttachment:'fixed',
             backgroundRepeat:'no-repeat',
             backgroundSize:'cover',
             objectFit:'cover'
          }}>
          <div className='about-kiga-slide-page-title'>
                 <p>Kigali</p>
                 <p>International</p>
                 <p>Gymnastic Academy</p>
      
          </div>
         </div>
      <div className="masonry">
        {
          GalleryPhoto?.map((el,index)=>(
        <img src={el?.image} alt="Ga" key={index}/>
          ))
        }
      </div>
      <Footer/>
    </>
  );
};

export default Gallery;
